import React from 'react';
import Styles from './mortgage-statement-sheet.scss';
const MortgageStatementSheet = ({ dueDate = '12/01/2024', principal, interest, monthly, amountDue, nameMain = 'Unknown', studentName = 'Student 1', statementDate, accountNumber, taxes, principalInterest, escrow, totalAmountDue, monthly2, escrow2, principalInterest2, lateFeeDate, paymentReceivedDate, lateFeeDate2, pmi, pmi2 }) => {
    return (React.createElement("div", { className: Styles.statementContainer },
        React.createElement("h1", { className: Styles.logo }, "KIDVESTORS"),
        React.createElement("br", null),
        React.createElement("div", { className: Styles.row },
            React.createElement("div", { className: Styles.topColumn },
                React.createElement("h2", null, "KV Mortgage"),
                React.createElement("div", { className: Styles.largeText },
                    React.createElement("b", null, nameMain)),
                React.createElement("div", { className: Styles.largeText }, "Customer service: 1-800-555-1234"),
                React.createElement("div", { className: Styles.largeText }, "www.kidvestors.co"),
                React.createElement("hr", null),
                React.createElement("div", { className: Styles.largeText }, studentName),
                React.createElement("div", { className: Styles.largeText }, "4700 Jones Drive"),
                React.createElement("div", { className: Styles.largeText }, "Memphis, TN 38109")),
            React.createElement("div", { className: Styles.topColumn },
                React.createElement("div", { className: Styles.mortgageStatementContainer },
                    React.createElement("h2", null, "Mortgage Statement"),
                    React.createElement("div", { className: Styles.largeText },
                        "Statement Date: ",
                        statementDate)),
                React.createElement("div", { className: Styles.amountDueContainer },
                    React.createElement("div", { className: Styles.amountDueRow },
                        React.createElement("div", { className: Styles.standardText }, "Account Number"),
                        React.createElement("div", { className: Styles.standardText }, accountNumber)),
                    React.createElement("div", { className: Styles.amountDueRow },
                        React.createElement("div", { className: Styles.standardText }, "Payment Due Date"),
                        React.createElement("div", { className: Styles.standardText }, dueDate)),
                    React.createElement("br", null),
                    React.createElement("div", { className: Styles.amountDueRow },
                        React.createElement("h3", null, "Amount Due"),
                        React.createElement("h3", null, amountDue)),
                    React.createElement("div", { className: Styles.smallText },
                        "If payment is received after ",
                        lateFeeDate2,
                        ", ",
                        taxes,
                        " late fee will be charged")))),
        React.createElement("br", null),
        React.createElement("div", { className: Styles.row },
            React.createElement("div", { className: Styles.bottomColumn },
                React.createElement("div", { className: Styles.bottomColumnRow },
                    React.createElement("div", { className: Styles.standardText }, "Outstanding Principal"),
                    React.createElement("div", { className: Styles.standardText }, principal)),
                React.createElement("div", { className: Styles.bottomColumnRow },
                    React.createElement("div", { className: Styles.standardText }, "Interest Rate"),
                    React.createElement("div", { className: Styles.standardText },
                        interest,
                        "%")),
                React.createElement("div", { className: Styles.bottomColumnRow },
                    React.createElement("div", { className: Styles.standardText }, "Prepayment Penalty"),
                    React.createElement("div", { className: Styles.standardText }, "YES"))),
            React.createElement("div", { className: Styles.bottomColumn },
                React.createElement("div", { className: Styles.bottomColumnRow },
                    React.createElement("div", { className: Styles.standardText }, "Principal & Interest"),
                    React.createElement("div", { className: Styles.standardText }, principalInterest)),
                pmi !== 'N/A' && (React.createElement("div", { className: Styles.bottomColumnRow },
                    React.createElement("div", { className: Styles.standardText }, "PMI"),
                    React.createElement("div", { className: Styles.standardText }, pmi))),
                React.createElement("div", { className: Styles.bottomColumnRow },
                    React.createElement("div", { className: Styles.standardText }, "Escrow"),
                    React.createElement("div", { className: Styles.standardText }, escrow)),
                React.createElement("div", { className: Styles.smallText }, "for Taxes and Insurance"),
                React.createElement("div", { className: Styles.bottomColumnRow },
                    React.createElement("h4", null, "Regular Monthly Payment"),
                    React.createElement("div", { className: Styles.standardText },
                        React.createElement("b", null, monthly))),
                React.createElement("div", { className: Styles.bottomColumnRow },
                    React.createElement("div", { className: Styles.standardText }, "Total Fees Charged"),
                    React.createElement("div", { className: Styles.standardText }, taxes)),
                React.createElement("hr", null),
                React.createElement("div", { className: Styles.bottomColumnRow },
                    React.createElement("h4", null, "Total Amount Due"),
                    React.createElement("div", { className: Styles.standardText },
                        React.createElement("b", null, totalAmountDue))))),
        React.createElement("br", null),
        React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Date"),
                    React.createElement("th", null, "Description"),
                    React.createElement("th", null, "Charges")),
                React.createElement("tr", null,
                    React.createElement("td", null, lateFeeDate),
                    React.createElement("td", null,
                        React.createElement("div", null, "Late fee"),
                        React.createElement("small", { style: { color: '#999' } },
                            "Charged because full payment was not received by ",
                            lateFeeDate)),
                    React.createElement("td", null, taxes)),
                React.createElement("tr", null,
                    React.createElement("td", null, paymentReceivedDate),
                    React.createElement("td", null,
                        React.createElement("small", { style: { color: '#999' } }, "Payment Received - Thank you")),
                    React.createElement("td", null, monthly)))),
        React.createElement("br", null),
        React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("th", null),
                    React.createElement("th", null, "Paid Last Month"),
                    React.createElement("th", null, "Paid Year to Date")),
                React.createElement("tr", null,
                    React.createElement("td", null, "Principal & Interest"),
                    React.createElement("td", null, principalInterest),
                    React.createElement("td", null, principalInterest2)),
                pmi !== 'N/A' && (React.createElement("tr", null,
                    React.createElement("td", null, "PMI"),
                    React.createElement("td", null, pmi),
                    React.createElement("td", null, pmi2))),
                React.createElement("tr", null,
                    React.createElement("td", null, "Escrow"),
                    React.createElement("td", null, escrow),
                    React.createElement("td", null, escrow2)),
                React.createElement("tr", null,
                    React.createElement("td", null, "Fees"),
                    React.createElement("td", null, "$0.00"),
                    React.createElement("td", null, "$0.00")),
                React.createElement("tr", null,
                    React.createElement("td", { className: Styles.totalText }, "Total"),
                    React.createElement("td", { className: Styles.totalText }, monthly),
                    React.createElement("td", { className: Styles.totalText }, monthly2))))));
};
export default MortgageStatementSheet;
